// *******************************************************************************
// Contact Module Form Validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const newsletterModule = document.querySelector('.newsletter-module');
  const newsletterModuleForm = document.getElementById('newsletter-module-form');
  if (newsletterModuleForm) {
    const recaptchaKey = document.querySelector('.recaptcha-button-box').getAttribute('data-sitekey');
    const fv = FormValidation.formValidation(newsletterModuleForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        // trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        if (!e.valid) {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: 'saveNewsletterModuleFormData' }).then((token) => {
            // Ajax check if valid
            const formData = {};
            const formDataInput = new FormData();
            newsletterModuleForm.querySelectorAll('input').forEach((input) => {
              if (input.type === 'email' || input.type === 'text') {
                formData[input.name] = input.value.trim();
              }
            });
            // Append the text fields
            formDataInput.append('action', 'saveNewsletterModuleFormData');
            formDataInput.append('nonce', document.querySelector('#newsletter-module-form-nonce').value);
            formDataInput.append('token', token);
            formDataInput.append('id', localData.id);
            formDataInput.append('lang', localData.lang);
            formDataInput.append('inputs', JSON.stringify(formData));
            axios
              .post(localData.siteURL, formDataInput, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data.url) {
                  window.location.replace(response.data.data.url);
                }
              })
              .catch((err) => {
                newsletterModuleForm.insertAdjacentHTML('afterend', `<div class="form-error-message : fv-plugins-message-container"><div class="margin : margin--40"></div>${err.response.data.data.msg}</div>`);
              });
          });
        });
      });
  }
});
